import form from "../form/Form"
export default {
    name:"externalForm",
    mixins:[form],
    created:function(){
        this.$store.commit("SetExternal");
    }
}